import { connect } from 'react-redux';
import { submitLogout } from '../../../actions/connexionActions';

// on importe le composant de présentation
import MainHeader from '../../../components/Header/MainHeader';

// === mapStateToProps
// si on a besoin de lire des informations dans le state
const mapStateToProps = (state) => ({
  // nom de la prop à remplir: élément à récupérer dans le state
  isAuthentified: state.connexionReducer.isAuthentified,
});

// === mapDispatchToProps
// si on a besoin de dispatcher des actions vers le store (modifier le state)
const mapDispatchToProps = (dispatch) => ({
  // nom de la prop à remplir: fonction qui dispatch l'action
  logout: () => {
    dispatch(submitLogout());
  }
});

// === création de l'assistant
export default connect(mapStateToProps, mapDispatchToProps)(MainHeader);